// JsFromRoutes CacheKey bd354786fa6b656756f07c922a85aed9
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/client"

export default {
  index: /* #__PURE__ */ definePathHelper("get", "/api/:venue_slug/sponsorships"),
  create: /* #__PURE__ */ definePathHelper("post", "/api/:venue_slug/sponsorships"),
  show: /* #__PURE__ */ definePathHelper("get", "/api/:venue_slug/sponsorships/:id"),
  update: /* #__PURE__ */ definePathHelper("patch", "/api/:venue_slug/sponsorships/:id"),
  destroy: /* #__PURE__ */ definePathHelper("delete", "/api/:venue_slug/sponsorships/:id"),
}
